export const METHODOLOGY_PDF_LINK =
  'https://net0-calculators-prod.s3.amazonaws.com/Methodology+-+Visit+Monaco+Calculator.pdf';
